export default __webpack_public_path__ + "static/media/nightmoon.3b551c98.jpg";